import { CLOUDFRONT_LOGOS_ROOT_URL } from '@shared/config/constants/app';

export const PT_CC_PHONE = '707450201';
export const PT_CC_EMAIL = 'support@360mea.com';
export const PT_UNSUBSCRIBE_PATH = '/dcb/unsubscribe/pt';
export const PT_UNSUBSCRIBE_SUCCESS_PATH = '/dcb/unsubscribe/pt?status=cancelled';
export const PT_DEFAULT_WEEKLY_PRICE = '2.99€';
export const PT_TERMS_URL = 'https://360vuz.com/TermsConditionsPrivacyPolicy.html';
export const PT_SERVICE_LOGO = `${CLOUDFRONT_LOGOS_ROOT_URL}/vuz/vuzvip.png`;
